import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
import "./AboutPage.css";



function AboutPage() {
    return(<div id="about-section" className="hidden bg-gray-900 text-white font-sans"  style={{fontFamily:  'Plus Jakarta Sans',
       maxWidth: "1220px",
        margin: "0 auto"
    }}>
  
      <br></br> <br></br>
      <div style={{ display: "flex", justifyContent: "center" }}>
    <img 
      src="gokdel.webp" 
      alt="Skyscrapers" 
      width="1200px" 
      height="489px" 
      className="animated-image"
    />
    <style>{`
    .animated-image {
      display: block;
      margin: 0 auto;
      opacity: 0;
      transform: translateY(30px);
      animation: fadeInUp 1s ease-out forwards;
      animation-delay: 0.3s;
    }
  
    @keyframes fadeInUp {
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `}</style>
  
  
     </div>
       
          <div className="text-center px-4">
           <br></br>
            <p className="animated-text mt-4 text-lg" color="#fff" style={{color:"#fff", fontSize: "24px"}}>
            At Briospark, we believe technology has the power not just to transform, but to redefine what's possible. Founded on principles of innovation, trust, and visionary thinking, we're dedicated to empowering organizations through cutting-edge software solutions, guiding them confidently into the digital future.
            </p>
            <style>{`
      .animated-text {
        opacity: 0;
        transform: translateY(20px);
        animation: fadeInText 1.2s ease-out forwards;
        animation-delay: 0.5s;
      }
  
      @keyframes fadeInText {
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `}</style>
          </div>
      
        
  <br></br>
        <hr className="border-gray-600 w-[70%]" />
      <br></br>
      
      <section className="max-w-4xl mx-auto px-4 py-12">
       
    
       <div className="text-center px-4">
        <p style={{fontSize : "36px", color : "#fff"}} >Turning Complexity into Clarity</p>
   
        <p className="text-gray-300 text-center max-w-3xl mx-auto  mb-6" style={{fontSize : "20px", color : "#9EABB8"}} >
          Specializing in digital transformation, telecommunications (OSS), and financial services.
        </p>
        <br></br>

        <p className="text-gray-400 text-center max-w-3xl mx-auto" style={{fontSize : "18px", color : "#fff"}}>
          Our solutions optimize operations, enhance efficiency, and deliver robust security, tailored specifically to meet the unique challenges faced by telecom and banking industries. By partnering closely with our clients, we turn complexity into clarity, enabling them to thrive in a rapidly evolving market.
        </p>
        
        <div className="my-12 text-center">
      
          <p style={{fontSize : "36px", color : "#fff"}}>Our mission is clear</p>
      
          <p className="text-gray-400 max-w-3xl mx-auto" style={{fontSize : "18px", color : "#fff"}}>
            Our mission is clear: harness the latest technology to elevate standards and redefine possibilities within telecom and finance. Driven by a relentless commitment to excellence, we combine deep industry knowledge with agile development practices to craft solutions that are both innovative and reliable.
          </p>
        </div>
    
        <div className="text-center text-xl font-medium text-white mt-16" >
          <br></br>
          <p style={{fontSize : "36px", color : "#fff"}}>Briospark isn’t just another tech provider. 
          We’re your trusted partner in building a smarter, more connected, and financially empowered future.</p>
        </div>
        </div>
      </section>
    </div>
    );
  }

  export default AboutPage;